import { render, staticRenderFns } from "./formOTP.vue?vue&type=template&id=9e2577ee&scoped=true"
import script from "./formOTP.vue?vue&type=script&lang=js"
export * from "./formOTP.vue?vue&type=script&lang=js"
import style0 from "./formOTP.vue?vue&type=style&index=0&id=9e2577ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2577ee",
  null
  
)

export default component.exports